export const courseInfoForm = {
  schoolId: '', // 服务学校id
  schoolName: '', // 学校名称
  areaCode: '',
  branchId: '', // 校区id (courseClassExtAddRO schBranchId)
  branchName: '', // 校区名称
  courseId: '', // 课程资源id
  courseName: '', // 课程资源名称
  // termId: '', // 年度学期id
  termName: '', // 年度学期名称
  classroomName: '', // 课班名称
  courseTypeId: [], // 课程资源类型id
  orgId: '', // 提供方id
  courseTypeName: '', // 课程类型名称(添加的时候并不需要)
  courseChannel: '0', // 课程渠道 0-机构课程 1-合作课程 2-平台课程
  hangingRuleId: '', // 挂靠分账规则id
  termCode: '',
  yearCode: ''
};

export const classHourInfoForm = {
  classroomTotal: '', // 累计课时
  classTime: '', // 单节时长
  courseDisplayPriceShow: '', // 课程显示价格
  courseDisplayPrice: '', // 课程显示(courseDisplayPriceShow*100)
  feeShow: '', // 课程价格
  fee: '', // 费用(feeShow*100)
  classDateBegin: '', // 预计开课开始时间
  classDateEnd: '', // 预计开课结束时间
  // 'arrangingRule': '', // 是否填完了预计上课时间这一栏
  arrangingRuleBo: {
    // 'schoolTimeList': [ // 上课时间
    //   {
    //     'weekDate': 0,
    //     'classTimeBegin': '2022-04-24 20:43:19',
    //     'classTimeEnd': '2022-04-24 20:43:19'
    //   }
    // ],
    // 'ruleType': 0 // 估计类型, 1-周循环 2-指定上课周
  }, // (courseClassExtAddRO)
  gradeMin: 1, // 推荐最小年级：小学初中高中分别对应1-12，幼儿园小中大班分别为13-15
  gradeMax: 12, // 推荐最大年级：小学初中高中分别对应1-12，幼儿园小中大班分别为13-15
  teacherIds: [], // 授课教师
  reqRoomCount: '', // 需求教室数 (courseClassExtAddRO)
  isHideClasstime: '0', // 是否显示课程开始时间 1:隐藏 0：显示
  isHideClasstimeTail: '0' // 是否显示课程结束时间 1:隐藏 0：显示
};

export const materialInfoForm = {
  reqAttachmentType: 0, // 0:不需要 1：必要 2：非必要
  addCourseClassMaterialRoList: [] // offerName（材料名称）、offerPrice（材料费用(分)）、divideConfigId（分账规则Id）
  // 'attachmentPriceShow': '', // 材料价格展示
  // 'attachmentPrice': '', // 材料费用（attachmentPriceShow*100）
  // 'attachmentDescribe': '' // 材料说明
};

export const enrollSettingInfoForm = {
  enrollTimeBegin: '', // 报名开始时间
  enrollTimeEnd: '', // 报名截止时间
  enrollTimeEndShow: '', // 展示
  studentTotal: '', // 班级总人数
  visibleDTOList: [
    // 可见范围
    // {
    //   'visibleId': 0, // 可见范围Id
    //   'orgId': 0, // 学校Id
    //   'branchId': 0, // 校区Id
    //   'gradeId': 0, // 年级Id
    //   'classId': 0, // 班级Id
    //   'limitCount': 0 // 人数限制
    // }
  ],

  isLimitEnroll: 0 // 圈定范围：0不限制 1按年级班级圈定 2限制个人
  // 'stuIds': [] // 圈定范围为个人时被圈定的学生ids
};

export const refundSettingInfoForm = {
  enableRefund: 0, // 退款申请许可：1：允许 0：不允许 (courseClassExtAddRO)
  refundDeadlineShow: '',
  refundDeadline: '' // 退款截止时间(courseClassExtAddRO)
};

export const predictionSettingInfoForm = {
  isPreEnroll: 0 // 是否预报名：1：是 0：否 {courseClassExtAddRO}
};

export const otherSettingInfoForm = {
  visibleType: 1, // 列表可见范围：0：不可见 1：可见 2：指定范围可见(courseClassExtAddRO)
  classroomState: 0, // 发布后商家 0：不上架 4：上架
  itemId: ''
};

export const courseDetailInfoForm = {
  courseCoverShow: null, // 课程封面展示图
  courseCover: '', // 课程封面 :前端传默认封面id(courseClassExtAddRO)
  context: '', // 介绍内容(courseClassExtAddRO)
  courseAchievementShow: [], // 成果展示图片展示的
  courseAchievement: '', // 成果展示(courseClassExtAddRO)
  courseNotice: '' // 报名须知(courseClassExtAddRO)
};

export const courseInfoRequired = {
  schoolId: {
    require: true,
    status: false
  },
  branchId: {
    require: true,
    status: false
  },
  courseId: {
    require: true,
    status: false
  },
  termId: {
    require: true,
    status: false
  },
  classroomName: {
    require: true,
    status: false
  },
  courseTypeId: {
    require: true,
    status: false
  }
};

export const classHourInfoRequired = {
  classroomTotal: {
    require: true,
    status: false
  },
  classTime: {
    require: false,
    status: false
  },
  feeShow: {
    require: true,
    status: false
  },
  classDateBegin: {
    require: false,
    status: false
  },
  classDateEnd: {
    require: false,
    status: false
  },
  arrangingRule: {
    require: true,
    status: false
  },
  reqRoomCount: {
    require: false,
    status: false
  }
};
